import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/buying/PeakPeriodSurcharges'

export default {
  async getAll(masterClassId, serviceType) {
    const dynamicURL = serviceType === 1 ? 'airport-transfer' : 'rental'
    return await axios
      .get(endpoint + `/${dynamicURL}/${masterClassId}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/master/buyingTariff/buyingTariffPeakPeriodSurchargeService.js